<template>
  <BaseRoundedButton
    :class="[
      $style.icon,
      $style.facebook
    ]"
    @click="$emit('click')"
  >
    <font-awesome-icon
      :icon="{ prefix: 'fab', iconName: 'facebook' }"
      size="2x"
      :class="$style.icon"
    />
  </BaseRoundedButton>
</template>

<script>
import BaseRoundedButton from '@/components/Atoms/BaseRoundedButton'
export default {
  name: 'FacebookIcon',
  components: {
    BaseRoundedButton,
  },
}
</script>

<style module lang="scss">
  .icon {
    color: white;
    transition: background-color .3s ease-in-out;
    margin: 0 .2rem;
  }
  .facebook {
    background-color: #3b5998;
    &:hover {
      background-color: darken(#3b5998, 5%);
    }
  }
</style>
